// Module
var code = `<div on-click="@this.onComboBoxClick(event)"
     class="js-accountsComboBox{{#if isPosAbsolute}} absolute{{/if}} {{.elementStyle}} {{.additionalClass}}{{#if .isShowDropdownMenu}} checked{{/if}}"
     as-tooltip="tooltip"
     style="{{>visibility}} {{#if isPosAbsolute}}{{>position}}{{/if}}"
     {{#.focused}} focused="" {{/}}
     {{#if !(.enabled) }} disabled="" {{/if}}>

     <div class="accountsComboBox-accItem">
        {{#if isMultiSelect}}
            <div class="accountsComboBox-selected-text">{{selectedItemsText}}</div>
        {{else}}
            <div class="{{selectedItemMode}}-accItem">{{selectedItemMode}}</div>
            <div class="accountsComboBox-accItem-name">{{selectedItemText}}</div>
        {{/if}}
    </div>

    <div class="js-accountsComboBox-right-container">
        <div class="js-accountsComboBox-arrow-down">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowDown"></use>
            </svg>
        </div>
    </div>
</div>`;
// Exports
export default code;